<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs">
    <app-loader [showLoader]=showLoad></app-loader>
    <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom">
        <div class="o-stack__cell">
            <h5>{{sectiontitle}}</h5>
        </div>
    </div>
    <div class="analytics-portlet-content">

        <div class="chart-container">
            <div id="chart" class="daily-stats-chart"></div>
        </div>
    </div>
</div>
